import cx from "classnames";
import { useState } from "react";
import { connect } from "react-redux";
import { withToast } from "../../../contexts/toastr.context";
import Tooltip from "../../../_components/atoms/tooltip";
import ComponentSwitcher from "../../../_components/component-switcher/component-switcher.component";
import IconButton2 from "../../../_components/icon-button-2-component";
import UIcon from "../../../_components/uicon-component";
import BulkMailListPage from "./component/bulk-mail-list.component";
import SendMailPage from "./component/send-bulk-mail.component";

export const BULK_MAIL_PAGE_ROUTE = "/settings/bulkmail";

/**
 * @description Send bulk mail to community or group users. Display list of sent mails.
 * @param {Object} user - Auth user object
 * @param {Object} community - Current community object
 * @param {Array<Object>} groups - List of groups
 * @param {Object} communityPac - Current community pac object
 */
function BulkMailPageComponent({
  user,
  community,
  communityPac,
  groups,
  addToast,
  monthlyLimit,
  monthlyLimitReset,
}) {
  const [displaySendMail, setDisplaySendMail] = useState(false);
  const [mailToDisplay, setMailToDisplay] = useState();

  // Refresh list of sent mails if value is changed [true, false]
  const [refreshMailList, setRefreshMailList] = useState(false);

  return (
    <div className="BulkMailPage px-4 sm:p-0">
      <Header
        refreshMailList={refreshMailList}
        setRefreshMailList={setRefreshMailList}
        displaySendMail={displaySendMail}
        setDisplaySendMail={(val) => {
          setDisplaySendMail(val);
          setMailToDisplay(undefined);
        }}
        monthlyLimit={monthlyLimit}
        monthlyLimitReset={monthlyLimitReset}
      />
      <ComponentSwitcher
        transition="fade"
        isActiveFirst={displaySendMail}
        child1={
          <SendMailPage
            user={user}
            community={community}
            groups={groups}
            addToast={addToast}
            mailToDisplay={mailToDisplay}
          />
        }
        child2={
          <BulkMailListPage
            user={user}
            community={community}
            groups={groups}
            refreshMailList={refreshMailList}
            addToast={addToast}
            setDisplaySendMail={setDisplaySendMail}
            setMailToDisplay={setMailToDisplay}
          />
        }
      />
    </div>
  );

  function Header({
    displaySendMail,
    setDisplaySendMail,
    refreshMailList,
    setRefreshMailList,
    monthlyLimit,
    monthlyLimitReset,
  }) {
    return (
      <>
        <div
          className={cx(
            "flex flex-col pl-4 pr-2  w-full theme-bg-surface shadow",
            {
              "py-4": displaySendMail,
              "py-2": !displaySendMail,
            }
          )}>
          <div className="w-full flex items-center justify-between">
            <div className="flex items-center justify-between w-full">
              <button
                className={cx("", {
                  "cursor-pointer": displaySendMail,
                  "cursor-default": !displaySendMail,
                })}
                onClick={(e) => {
                  if (displaySendMail) setDisplaySendMail(false);
                }}>
                {displaySendMail ? (
                  <span className="flex items-center space-x-2">
                    <UIcon icon="angle-left" />
                    <span>Send Mail</span>
                  </span>
                ) : (
                  "Bulk Mail"
                )}
              </button>
              {displaySendMail ? (
                <>
                  {monthlyLimit ? (
                    <div>
                      {monthlyLimit} bulk email remaining this month. Resets at{" "}
                      {monthlyLimitReset}.
                    </div>
                  ) : (
                    <></>
                  )}
                </>
              ) : (
                <div className="flex space-x-2">
                  <Tooltip label="Refresh Mails">
                    <IconButton2
                      icon="rotate-right"
                      hoverable
                      onClick={() => {
                        setRefreshMailList(!refreshMailList);
                      }}
                    />
                  </Tooltip>
                  <Tooltip label="Send Bulk Mail">
                    <IconButton2
                      icon="envelope-plus"
                      hoverable
                      onClick={() => {
                        setDisplaySendMail(!displaySendMail);
                      }}
                    />
                  </Tooltip>
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}

const BulkMailPage = withToast(
  connect((s) => ({
    user: s.auth,
    community: s.community,
    communityPac: s.communityPac,
    groups: s.groups,
  }))(BulkMailPageComponent)
);

export default BulkMailPage;
